import { useDocumentTitle as useSetDocumentTitle } from 'usehooks-ts';
import { useRouteTitle } from './useRouteTitle';

export const useDocumentTitle = () => {
    const title = useRouteTitle();

    useSetDocumentTitle(title);
};
